
  import React, { Component } from "react";
  import { Button, Form, Image,  } from "react-bootstrap";
  import configData from "../config.json";
  import { toast } from "react-toastify";
  import Aadhaar from "./Aadhaar.png";
  import mobile from "./mobile.png";
  import "./Abha.css";
  import ReCAPTCHA from 'react-google-recaptcha';

  export default class AbhaAddressverfi extends Component {
    constructor(props) {
      super(props);
    this.recaptchaRef = React.createRef();
      this.state = {
        requestId: sessionStorage.getItem("requestId"),
        abhaAddress: "",
        abhaaddressotp: ["", "", "", "", "", ""],
        AbhaProfile: {},
        otpResponseMsg: "",
        mobile: "",
        showOtp: false,
        showAbha: false,
        showAbhaAddress: false,
        showAddessotp: false,
        cabhaaddress: "",
        custshowAddess: false,
        isAbhaVerifiedReady: false,
        authMethods: [],
        selectedAuthMethod:"",
        resendTimer: 60, // 10 minutes
        resendEnabled: false,
        resendIntervalId: null,
        captchaToken:null,
        // ["aadhaarotp", "mobileotp"]
      };
    }
    handleCaptchaChange = (value) => {
      this.setState({
        captchaToken: value,
      });
    };
    resetCaptcha = () => {
      this.setState({ captchaToken: "" });
      if (this.recaptchaRef && this.recaptchaRef.current) {
        this.recaptchaRef.current.reset();
      }
    };


    componentDidMount() {
      // this.ResponseHandler();
      if (!sessionStorage.getItem("resendOtpABAVeCount")) {
        sessionStorage.setItem("resendOtpABAVeCount", "0");
      }
    
      // this.startResendTimer();
    }
    validateAbhaAddress = (input) => {
      const minLength = 8;
      const maxLength = 18;
      const regex = /^[a-zA-Z0-9]+([._]?[a-zA-Z0-9]+)*$/;
    
      const startsOrEndsWithSpecial = /^[._]|[._]$/.test(input);
      const dotCount = (input.match(/\./g) || []).length;
      const underscoreCount = (input.match(/_/g) || []).length;
    
      return (
        input.length >= minLength &&
        input.length <= maxLength &&
        regex.test(input) &&
        !startsOrEndsWithSpecial &&
        dotCount <= 1 &&
        underscoreCount <= 1
      );
    };// ✅ ABHA Address Validation (supports @abdm & @abdm)
    isValidAbhaAddress(address) {
      const regex = /^[a-zA-Z0-9._]{6,18}@(abdm)$/;
      return regex.test(address);
    }
    getAuthMethodsForAbhaAddress = () => {
      const { abhaAddress } = this.state;
    
      // 1. Empty check
      if (!abhaAddress) {
        this.showToast("Please enter ABHA Address", "error");
        return;
      }
    
      // 2. Format validation
      if (!this.isValidAbhaAddress(abhaAddress)) {
        this.showToast("Invalid ABHA Address", "error");
        return;
      }
    
      // ✅ Proceed only if valid
      const formData = new FormData();
      formData.append("abhaAddress", abhaAddress);
    
      fetch(configData.api_url + "C_Abhaaddress/getAuthMethodsByabhaAddress", {
        method: "POST",
        mode: "cors",
        body: formData,
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "success") {
            console.log("Available Auth Methods:", data.detail);
            this.showToast("Auth methods fetched", "success");
            sessionStorage.setItem("requestId", data.requestId);
    
            const availableMethods = data.abhaDetails?.authMethods || [];
            this.setState({
              authMethods: availableMethods,
              showAuthSelection: availableMethods.length > 0,
            });
    
            // 🚨 Non-KYC handling (store in session instead of toast)
            if (!data.abhaDetails?.healthIdNumber) {
              sessionStorage.setItem("nonKycFlag", "1"); // save flag
            } else {
              sessionStorage.removeItem("nonKycFlag"); // clear if KYC
            }
          } else {
            this.showToast(data.message || "Failed to fetch auth methods", "error");
            setTimeout(() => {
              this.showToast("User Not Found. Please create using Aadhaar Number", "error");
              window.location.href = "/consentcollectionaadhaar";
            }, 5000);
          }
        });
    };
    
    
    
    // getAuthMethodsForAbhaAddress = () => {
    //   const { abhaAddress } = this.state;
    
    //   if (!abhaAddress) {
    //     this.showToast("Please enter ABHA Address", "error");
    //     return;
    //   }
    
    //   const formData = new FormData();
    //   formData.append("abhaAddress", abhaAddress);
    // // formData.append("requestId", "2");
    //   fetch(configData.api_url + "C_Abhaaddress/getAuthMethodsByabhaAddress", {
    //     method: "POST",
    //     mode: "cors",
    //     body: formData,
    //   })
    //     .then((res) => res.json())
    //     .then((data) => {
    //       if (data.status === "success") {
    //         console.log("Available Auth Methods:", data.detail);
    //         this.showToast("Auth methods fetched", "success");
    //         sessionStorage.setItem("requestId", data.requestId);
    //         // You may store them in state if needed
    //         const availableMethods = data.abhaDetails?.authMethods || [];
    //         this.setState({ 
    //           authMethods: availableMethods,
    //           showAuthSelection: availableMethods.length > 0
    //         })
    //         if (!data.abhaDetails?.healthIdNumber) { this.showToast("This is a non-KYC ABHA address. Please link your ABHA address to your ABHA number to enable download",     
    //           "error"); 
    //           return;
    //         }
  
    //       } else {
    //         this.showToast(data.message || "Failed to fetch auth methods", "error");
    //         setTimeout(() => {
    //           // Redirect to consent collection page if no auth methods found
    //           this.showToast("User Not Found please create using Aadhaar Number","error");
    //           window.location.href = "/consentcollectionaadhaar";
    //         }, 5000);
    //       }
    //     })
    //     .catch(() => {
    //       this.showToast("Server error while fetching auth methods", "error");
    //     });
    // };
  showToast = (msg, type) => {
      switch (type) {
        case "success":
          toast.success(msg);
          break;
        case "error":
          toast.error(msg);
          break;
        case "warning":
        toast.warn(msg);
          break;
      default:toast.success(msg);
      }
    };
    // handleImageClick = (option) => {
    //   this.setState({ authMethods: option });
    // };
    handleImageClick = (method) => {
      this.setState({ selectedAuthMethod: method });
    };

    handleabhaaddressotpChange = (e, index) => {
      const val = e.target.value;
      if (/^\d?$/.test(val)) {
        this.setState(
          (prevState) => {
            const newOtp = [...prevState.abhaaddressotp];
            newOtp[index] = val;
            return { abhaaddressotp: newOtp };
          },
          () => {
            if (val && index < 5) {
              this[`otpInput1${index + 1}`].focus();
            }
          }
        );
      }
    };

    handleABHAAddressSearchNext = (e) => {
      e.preventDefault();
      const { abhaAddress, authMethods } = this.state;
      if (!authMethods) {
        this.showToast("Please select Aadhaar or Mobile OTP option.", "error");
        return;
      }
      sessionStorage.setItem("abhaAddress", abhaAddress);
      const formData = new FormData();
      formData.append("abhaAddress", abhaAddress);
      formData.append("authMethods", authMethods);
      formData.append("requestId", sessionStorage.getItem("requestId"));

      fetch(configData.api_url + "C_Abhaaddress/getAuthMethodsByabhaAddress", {
        method: "POST",
        mode: "cors",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === "success") {
            this.showToast(data.message, data.status);
            sessionStorage.setItem("message", data.message);
            sessionStorage.setItem("resendOtpABAVeCount", "");
            this.setState({ isAbhaVerifiedReady: true }); // changed from data.details.message
          } else {
            this.showToast(data.message || "Something went wrong", "error");

            this.setState({
              resendOtpABAVeCount: "",
            });
          }
        });
    };
    handleABHAAddressSubmitNext = (e) => {
      e.preventDefault();
      const { abhaAddress, selectedAuthMethod ,captchaToken} = this.state;
      sessionStorage.setItem("otpResponseMsg",this.state.otpResponseMsg);
      sessionStorage.setItem("abhaAddress", abhaAddress);
      if (!captchaToken) {
         this.showToast('Please verify that you are not a robot!',"error");
        return;
      }
      if (!selectedAuthMethod) {
        this.showToast("Please select Aadhaar OTP or Mobile OTP to proceed.", "error");
        return;
      }
      const formData = new FormData();
      formData.append("abhaAddress", abhaAddress);
      formData.append("authMethods", selectedAuthMethod);
      formData.append("captchaToken", captchaToken);
      formData.append("requestId", sessionStorage.requestId);

      fetch(configData.api_url + "C_Abhaaddress/submitAbhaAddress", {
        method: "POST",
        mode: "cors",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === "success") {
            const otpMsg = data.details?.message || data.message;
             sessionStorage.setItem("otpResponseMsg", otpMsg);
            sessionStorage.setItem("otpResponseMsg", otpMsg);
            this.setState({

              otpResponseMsg: data.details.message, // store message for <p> tag
              responseMessage: "",
              showMessage: false,
            });

            this.showToast(data.message, "success");
            window.location.href = "/abhaaddressverfiotp";
          } else {
            this.setState({
              responseMessage: data?.details?.message || data.message,
              showMessage: true,
            });
            this.showToast(data.message || "Something went wrong", "error");
          }
        })
      
    };

    onKeyDownONE = (e, idx) => {
      if (e.key === "Backspace" && !this.state.abhaaddressotp[idx] && idx > 0) {
        this[`otpInput1${idx - 1}`].focus();
      }
    };
    handleabhaaddressChange = (e) => {
      e.preventDefault();
      this.setState({ abhaAddress: e.target.value || "" }); 
    };

    HandleClick = () => {
      this.setState({ isSubmitting: true });
      var formData = new FormData();
      formData.append("requestId", this.state.requestId);
      fetch(configData.api_url + "C_Abhaaddress/retriveAbhacard", {
        method: "POST",
        mode: "cors",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          this.showToast(data.message);
          if (data.status === "success") {
          }
          this.setState({
            isSubmitting: false,
          });
        });
    };

    HandleNextSubmit = () => {
      window.location.href = "/abhaprofile";
    };
    HandleNewClick = () => {
   window.location.href = "/Abharegister";
    };
    handlenextClick = () => {
      const { abhanumber, aadharNumber } = this.state;
      sessionStorage.setItem("abhaAddress", this.state.AbhaProfile.phrAddress);
      sessionStorage.setItem("aadharNumber", aadharNumber);
      sessionStorage.setItem("abhanumber", abhanumber);

      window.location.href = "/abhaprofile ";
    };

    render() {
      const {
        showAbhaAddress,
        abhaAddress,selectedAuthMethod ,
        authMethods,
      
      } = this.state;
      const methodIcons = {
        AADHAAR_OTP: Aadhaar,
        MOBILE_OTP: mobile,
      };
  
      return (
        <div>
      
          <div className="row justify-content-md-center text-center abhaAddressVerificationSection">
            <div className="col-md-6 mt-3">
              <div className="widget_BG widget_BG_grid mb-2">
                <Form.Group>
                  <Form.Label>
                    <b>ABHA Address</b>
                  </Form.Label>
                  <div className="d-flex gap-2">
                    <Form.Control
                      type={showAbhaAddress ? "text" : "password"}
                      value={abhaAddress}
                      onChange={this.handleabhaaddressChange}
                      className="form-control"
                      onKeyDown={this.onKeyDown}
                    />
        
                    <Button
                      variant="outline-secondary"
                      className={`rounded-0 bi ${
                        showAbhaAddress ? "bi-eye-slash" : "bi-eye"
                      }`}
                      onClick={() =>
                        this.setState({ showAbhaAddress: !showAbhaAddress })
                      }
                    />
                  </div>
                  <Button   className="rounded-0 m-3" onClick={this.getAuthMethodsForAbhaAddress}>Get ABHA Address</Button>
                  {/* {this.state.showAuthSelection && (
                  <div className="row justify-content-md-center mt-3 selectAadhaarMobileOtp">
                    <p>Validate using</p>

                    <div className="col text-center">
                      <div
                        onClick={() => this.handleImageClick("aadhaarotp")}
                        style={{
                          border:
                            authMethods === "aadhaarotp"
                              ? "2px solid blue"
                              : "1px solid #ccc",
                          padding: "10px",
                          cursor: "pointer",
                          borderRadius: "5px",
                        }}
                      >
                        <Image
                          src={Aadhaar}
                          className=""
                          alt="Aadhaar"
                          style={{
                            // width: "",
                            height: "44px",
                            marginBottom: "5px",
                          }}
                        />
                        <Form.Check
                          label="Aadhaar OTP"
                          name="otpMethod"
                          type="radio"
                          disabled
                          checked={authMethods === "aadhaarotp"}
                        />
                      </div>
                    </div>

                    <div className="col text-center ">
                      <div
                        onClick={() => this.handleImageClick("mobileotp")}
                        style={{
                          border:
                            authMethods === "mobileotp"
                              ? "2px solid blue"
                              : "1px solid #ccc",
                          padding: "10px",
                          cursor: "pointer",
                          borderRadius: "5px",
                        }}
                      >
                        <Image
                          src={mobile}
                          className=""
                          alt="Mobile"
                          style={{
                            width: "auto",
                            height: "44px",
                            marginBottom: "5px",
                          }}
                        />
                        <Form.Check
                          label="Mobile OTP"
                          name="otpMethod"
                          type="radio"
                          disabled
                          checked={authMethods === "mobileotp"}
                        />
                      </div>
                    </div>
                  </div>
                  )} */}
                  {this.state.showAuthSelection && (
                  <div className="row justify-content-md-center mt-3 selectAadhaarMobileOtp">
                    <p>Validate using</p>
                    {authMethods.map((method) => (
                      <div key={method} className="col text-center">
                        <div
                          onClick={() => this.handleImageClick(method)}
                          style={{
                            border:
                              selectedAuthMethod === method
                                ? "2px solid blue"
                                : "1px solid #ccc",
                            padding: "10px",
                            cursor: "pointer",
                            borderRadius: "5px",
                          }}
                        >
                            
                          <Image
                            src={methodIcons[method]}
                            alt={method}
                            style={{ height: "44px", marginBottom: "5px" }}
                          />
                          <Form.Check
                            label={
                              method === "AADHAAR_OTP"
                                ? "Aadhaar OTP"
                                : "Mobile OTP"
                            }
                            name="otpMethod"
                            type="radio"
                            checked={selectedAuthMethod === method}
                            readOnly
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                  <div className="col mt-3">
                              
                              <div className="d-flex">   <ReCAPTCHA 
                      className="mt-4"
                      ref={this.recaptchaRef} 
                      sitekey= {configData.captchaKey}
                      onChange={this.handleCaptchaChange}
                      /> 
                      <Button variant="secondary"  className="bi bi-arrow-clockwise re-chaptue" 
                              onClick={() => this.recaptchaRef.current.reset()}/>
                      </div>
                                
                              </div>
                  
                </Form.Group>
                {this.state.otpResponseMsg && (
              <p style={{ color: "green", fontWeight: "bold" }}>
                {this.state.otpResponseMsg}
              </p>
            )}
            
              </div>
            </div>
          </div>
          <div className="row  widget_BG widget_BG_grid m-0 mt-2">
          <div className="col text-start">
        <Button className="rounded-0 m-1 " variant="warning"
                          onClick={this.HandleNewClick}
                      
                      >
                        Back
                      </Button>
              </div>
            <div className="col text-end">
              
            <Button
                
                className="rounded-0 m-3"
                onClick={this.handleABHAAddressSubmitNext}
              >
                Verify ABHA Address
              </Button>
            </div>
          </div>
        </div>
      );
    }
  }
